function HomeHeroSection({ brandName, heroDescription, heroTitle, highlights }) {
  return (
    <header className="mx-auto w-[min(1120px,calc(100%-40px))] py-10 md:pb-7" id="top">
      <div className="rounded-[28px] border border-[#1832281a] bg-[rgba(249,245,238,0.88)] px-[20px] py-10 shadow-[0_22px_60px_rgba(24,50,40,0.08)] sm:px-[36px] lg:px-[52px]">
        <p className="mb-3.5 text-xs uppercase tracking-[0.16em] text-[#7c6b52]">{brandName}</p>
        <h1 className="max-w-[14ch] font-serif text-[clamp(2.6rem,5.6vw,4.4rem)] font-semibold leading-[1.04] text-[#163127] max-sm:max-w-none">
          {heroTitle}
        </h1>
        <p className="mt-6 max-w-[64ch] text-[1.05rem] leading-[1.7] text-[#355046]">{heroDescription}</p>
        <div className="mt-[30px] flex flex-wrap gap-3.5">
          <a
            className="inline-flex min-h-12 items-center justify-center rounded-full bg-[#1d4c3b] px-[22px] font-semibold text-[#f9f5ee] no-underline"
            href="#eiendommer"
          >
            Se eiendommer
          </a>
          <a
            className="inline-flex min-h-12 items-center justify-center rounded-full border border-[rgba(29,76,59,0.18)] bg-[rgba(255,255,255,0.7)] px-[22px] font-semibold text-[#1d4c3b] no-underline"
            href="#kontakt"
          >
            Kontakt oss
          </a>
        </div>
        <div className="mt-8 grid gap-4 md:grid-cols-3">
          {highlights.map((item) => (
            <article
              className="rounded-[22px] border border-[#18322812] bg-[rgba(255,255,255,0.56)] px-5 py-4 shadow-[0_12px_28px_rgba(24,50,40,0.05)]"
              key={item}
            >
              <p className="mb-2 text-xs uppercase tracking-[0.14em] text-[#7c6b52]">Dette finner du her</p>
              <p className="m-0 text-[1rem] leading-[1.65] text-[#355046]">{item}</p>
            </article>
          ))}
        </div>
      </div>
    </header>
  );
}

export default HomeHeroSection;